import { render, staticRenderFns } from "./HiddenRejectDialog.vue?vue&type=template&id=20ae4ed8&scoped=true"
import script from "./HiddenRejectDialog.vue?vue&type=script&lang=js"
export * from "./HiddenRejectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae4ed8",
  null
  
)

export default component.exports